const StatCard = ({ icon: Icon, value, label, change, color, onClick }) => {
    const colorClasses = {
        blue: {
            bg: 'bg-blue-50',
            iconBg: 'bg-blue-600',
            text: 'text-blue-800',
            change: 'text-blue-600'
        },
        green: {
            bg: 'bg-green-50',
            iconBg: 'bg-green-600',
            text: 'text-green-800',
            change: 'text-green-600'
        }
    };

    const colors = colorClasses[color];
    const isClickable = !!onClick;

    return (
        <div 
            onClick={onClick}
            className={`${colors.bg} border-2 border-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 group ${isClickable ? 'cursor-pointer hover:border-primary-200' : ''}`}
        >
            <div className="flex items-center justify-between mb-4">
                <div className={`p-3 ${colors.iconBg} rounded-xl group-hover:scale-110 transition-transform duration-300`}>
                    <Icon className="w-6 h-6 text-white"/>
                </div>
                <div className="text-right">
                    <p className="text-sm font-medium text-secondary-600">{label}</p>
                </div>
            </div>
            <div className="space-y-2">
                <p className={`text-4xl font-bold ${colors.text} group-hover:scale-105 transition-transform duration-300`}>
                    {value}
                </p>
                <p className={`text-sm font-medium ${colors.change}`}>
                    {change}
                </p>
            </div>
        </div>
    );
};

export default StatCard;